/**
 * The delimiter used to join entries in the generated files.
 */
export const ENTRIES_DELIMITER = '\n  ';

/**
 * Custom content prepended to all generated files.
 */
export const FILE_HEADER = `/* istanbul ignore file */
/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script \`localizations-codegen\`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run \`npx localizations-codegen\` to regenerate.
 */`;
export const TRANSLATIONS_CACHE_MAX_AGE = 15;
export const TRANSLATIONS_ENDPOINT = '/system/ajax/Localization/Translate';
export const TRANSLATIONS_QUERY_PARAMETER_NAME = 'keys';
export const DYNAMIC_TRANSLATION_PREFIX = '_dynamic_translation_';
//# sourceMappingURL=index.js.map